<template>
  <div class="create_question_wrap">
    <div class="create_question_title">
      <h2>创建实操题</h2>
      <div class="btn">
        <el-button @click="saveQuestion('next','ruleForm')">保存并继续</el-button>
        <el-button @click="saveQuestion('back','ruleForm')">保存并返回</el-button>
        <el-button @click="closeCreateQuestion">返回</el-button>
      </div>
    </div>
    <div class="create_question_main" :style="'height:'+(windowHeight-65)+'px'">
      <div class="questions_info">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item v-if="isShowResourceClassify" label="资源分类：" prop="resourceCategoryId" style="width: 100%">
            <el-select class="resource_classify" v-model="ruleForm.resourceCategoryId" placeholder="请选择资源分类">
              <el-option
                v-for="item in resourceDatas"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="科目：" prop="subjectValue" style="width: 25%">
            <p>{{subjectName}}</p>
          </el-form-item>
          <el-form-item label="难度：" prop="difficulty" style="width: 30%">
            <el-select v-model="ruleForm.difficultyValue" placeholder="请选择难度">
              <el-option
                v-for="item in difficultyOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="建议分数：" prop="gradeValue" style="width: 40%">
              <el-input v-model="ruleForm.gradeValue"></el-input>
          </el-form-item>
          <el-form-item label="用途：" prop="labelId" style="width: 25%">
            <p>{{labelName}}</p>
          </el-form-item>
          <el-form-item label="公司：" prop="companyId" style="width: 30%">
            <el-select v-model="ruleForm.companyId" placeholder="请选择公司" clearable >
              <el-option
                v-for="item in companyDatas"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="试题标题：" prop="questionTitle" class="questionTitlt" style="width: 40%">
            <el-input v-model="ruleForm.questionTitle" maxlength="20" placeholder="请输入试题标题"></el-input>
          </el-form-item>
          <el-form-item label="知识点：" prop="knowledgePoints" class="knowledgePoint" style="width: 100%">
            <el-select v-model="ruleForm.knowledgePoints" multiple placeholder="请选择知识点">
              <div v-if="knowledgePointsList.length>0">
                <el-option v-for="item in knowledgePointsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="标签：" prop="label" class="labelWrap" style="width: 100%">
            <el-select v-model="ruleForm.label" multiple placeholder="请选择标签" filterable>
              <div v-if="labelList.length>0">
                <el-option v-for="item in labelList" :key="item.id" :label="item.labelName" :value="item.id" class="label_option">
                  {{item.labelName}}
                  <i class="el-icon-error delete_label" @click.stop="deleteLabel(item)"></i>
                </el-option>
              </div>
            </el-select>
            <div class="customLabel">
              <el-input v-model.trim="ruleForm.customLabel" placeholder="请输入自定义标签" maxlength="20"></el-input>
              <el-button @click="createLabel">＋</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 题型提示 -->
      <p class="questionsTypes-tabs">
        <el-tabs v-model="ruleForm.addTestTypeId" @tab-click="handleClick">
          <el-tab-pane
            :label="item.questiontypeName"
            :name="item.id.toString()"
            v-for="(item, index) in ruleForm.addTestTypeOptions"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
      </p>
      <!-- 题型展示 -->
      <div class="question-types-area">
          <!-- <component :is="item.comp" v-model="item.value" :myRef="item.comp+index"></component> -->
          <component :is="comp" v-model="compValue" ref="GroupComp" :isUploading="isUploading" @changeUploadStatus="changeUploadStatus"></component>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../../../api/courseApi'
import * as newApi from "../../../../api/newCourseApi.js";
import vLabels from "./v_labels";
import addTestPracticalTest from "./addTestPracticalTest"; // 实操题
export default {
  components: {
    addTestPracticalTest,
    vLabels,
  },
  props: {
    createQuestionShow: {
      type: Boolean,
      default: false
    },
    isShowResourceClassify: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: [String, Number],
      default: 0,
    },
  },
  inject: ['reload'],
  data(){
    var checkGrade = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('分数不能为空'));
      } else if (parseInt(value) <= 0 || parseInt(value) > 999 || isNaN(parseInt(value))) {
        return callback(new Error('请填写正确分数'));
      } else {
        callback();
      }
    }
    return {
      loading: true,
      windowHeight: window.innerHeight,
      subjectId: this.$route.query.subjectId,//科目ID
      subjectName: '',//科目名称
      productFlag: sessionStorage.getItem('productFlag'),
      labelId: '',//用途ID
      labelName: '',//用途名称
      ruleForm: {
        difficultyValue: '1', // 难度id
        gradeValue: 1, // 分数
        companyId: null, //公司
        questionTitle: null, // 试题标题
        knowledgePoints: [], // 知识点
        addTestTypeId: null, // 题型id
        addTestType_internaltypeid: 9,// 内部题型id
        addTestTypeName: null, // 所选题型
        addTestTypeOptions: [], // 题型列表
        label: '',//所选标签
        customLabel: '',//自定义标签
        resourceCategoryId: "", // 资源分类
      },
      resourceDatas: [],
      rules: {
        resourceCategoryId: [ { required: true, message: '请选择资源分类', trigger: 'change' } ],
        knowledgePoints: [ { required: true, message: '请选择知识点', trigger: 'change' } ],
        gradeValue: [ { required: true, validator: checkGrade, trigger: 'blur' } ],
        questionTitle: [ { required: true, message: '请输入试题标题', trigger: 'blur' } ],
      },
      difficultyOptions: [ //难度列表
        { id: "1", label: "简单" },
        { id: "2", label: "中等" },
        { id: "3", label: "困难" }
      ],
      companyDatas: [], //公司列表
      knowledgePointsList: [], //知识点列表
      labelList: [],//标签列表
      compValue: {},//题干
      //================================
          comp: null,
          dialogVisible: false,
          treeList: [],
          defaultProps: {
              // tree显示字段
              label: "name",
              children: 'children',
          },
          isUploading: false,
          isDisabledSaveOn: false,
          isDisabledSaveBack: false,
          isDisabledOfSaveLabelBtn: false,
          isDisabledOfDeleteLabelBtn: false,
          // popover
          checkedTopic: [],
          popover_value: null
      }
  },
  mounted(){
    this.getMaterial()
    this.queryLabels()
    this.getKnowledgePoints()
    this.getLabelList()
    this.findTypeBySubject()
    this.findResCategoryByCourseId()

    if(this.productFlag==1){
      this.labelName = '书证融通'
      this.rules.questionTitle[0].required = false
    }else if(this.productFlag==2){
      this.labelName = '单项训练'
      this.rules.questionTitle[0].required = false
    }else if(this.productFlag==3||this.productFlag==7){
      this.labelName = '综合实训'
      this.rules.questionTitle[0].required = true
    }else if(this.productFlag==4){
      this.labelName = '真实任务'
      this.rules.questionTitle[0].required = false
    }
  },
  filters: {
    formatTime(time) {
      return (time = time.slice(0, 10) + " " + time.slice(11, 19));
    },
  },
  methods:{
    // 查询资源分类
    findResCategoryByCourseId() {
      newApi
        .FindResCategoryByCourseId(this.courseId)
        .then((res) => {
          if (res.code == "0") {
            this.resourceDatas = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMaterial(){//获取科目树
      let that = this;
      api.getMaterial().then((rs)=>{
        if(rs.code == 0){
          if(rs.data.length>0){
            rs.data.forEach(v=>{
              if(that.subjectId == v.id){
                that.subjectName = v.name
              }
            })
          }
        }else{
          this.$messageError(rs.msg)
        }
      }).catch((error)=>{
        console.log(error)
      })
    },
    queryLabels() {//查询用途
      api.getQuestionPurpose().then(rs => {
        if(rs.code==0){
          rs.data.forEach(v=>{
            if(this.labelName == v.labelName){
              this.labelId = v.id
            }
          })
        }else{
          this.$messageError(rs.msg)
        }
      }).then(()=>{
        this.getCompanyDatas()
      })
    },
    getCompanyDatas(){//根据科目及用途获取公司
			let arr = [];
			arr.push(this.labelId)
      api.queryCompany({
        subjectId: this.subjectId,
        lableIds: arr,
      }).then(rs=>{
        if (rs.code == 0) {
          this.companyDatas = rs.data
        } else {
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getKnowledgePoints(){//获取知识点
      let that = this
      api.FindMaterials(this.subjectId).then(rs=>{
        if(rs.code==0){
          that.knowledgePointsList = []
          that.treeData(rs.data.materials)
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    treeData(data){//遍历childre
      let that = this
      let obj = null
      for(let i=0;i<data.length;i++){
        obj = {
          name: data[i].name,
          id: data[i].id,
        }
        this.knowledgePointsList.push(obj)
        if(data[i].children.length==0){
          data[i].children=undefined;
        }else{
          this.treeData(data[i].children)
        }
      }
      return data
    },
    getLabelList(){//查询标签(lableType--0:用途、1:标签)
      this.labelList = []
      api.getQuestionPurpose({lableType: 1}).then(rs=>{
        if(rs.code==0){
          this.labelList = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    deleteLabel(item){//删除标签
      let obj = {
        labelId: item.id,
        questionId: null
      }
      this.$tipsDialog(
        "提示",
        "是否删除该自定义标签?",
        "",
        "el-icon-warning",
        "rgb(255, 178, 60)"
      ).then(() => {
        api.DeleteLable([obj]).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('删除成功')
            this.labelList.forEach((v,i)=>{
              if(v.id == item.id){
                this.labelList.splice(i,1)
              }
            })
            this.ruleForm.label.forEach((v,i)=>{
              if(v == item.id){
                this.ruleForm.label.splice(i,1)
              }
            })
          }else{
            this.$messageError(rs.msg)
          }
        }).catch((error) => {
          console.log(error)
        });
      }).catch(() => {

      });
    },
    createLabel(){//创建自定义标签
      if(this.ruleForm.customLabel==''){
        this.$messageWarning('请输入自定义标签')
        return
      }
      api.InsertLable({
        labelName: this.ruleForm.customLabel
      }).then(rs=>{
        if(rs.code==0){
          let obj = {
            id: rs.data,
            labelName: this.ruleForm.customLabel
          }
          this.labelList.push(obj)
          this.ruleForm.label.push(rs.data)
          this.ruleForm.customLabel = ''
          this.$messageSuccess('新增标签成功')
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    findTypeBySubject() {// 根据科目查询题型
      api.FindTypeBySubject({
          subjectId: this.subjectId
      }).then(res => {
        if (res.code === "0") {
          this.ruleForm.addTestTypeOptions = []
          if(res.data.length>0){
            res.data.forEach(v=>{
              if(v.internaltypeid==9){
                this.ruleForm.addTestTypeOptions.push(v)

              }
            })
            this.ruleForm.addTestTypeId = String(this.ruleForm.addTestTypeOptions[0].id);
            this.testTypeChange()
            // if ( this.handleType === "create" ) {

            // } else {
            //     this.ruleForm.addTestTypeId = res.data[0].id.toString();
            //     this.ruleForm.addTestType_internaltypeid = res.data[0].internaltypeid;
            //     this.testTypeChange()
            // }
            // this.setQuestionTypes(res.data.data);
            // session 保存题型
            // sessionStorage.setItem("addTestTypes", JSON.stringify(res.data));
          }else{
            this.$messageWarning('该科目下暂无题型，请先去“题型管理”添加题型！')
          }
        } else {
          this.$messageError(res.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    // tab切换
    handleClick(tab) {
      this.compValue = {} // 重置comp的val值
      this.ruleForm.addTestTypeOptions.forEach(val=>{
        if (val.id == tab.name) {
          this.ruleForm.addTestType_internaltypeid = val.internaltypeid
          this.ruleForm.addTestTypeId = val.id.toString()
          this.testTypeChange()
        }
      })
    },
    // 切换题型
    testTypeChange() {
      this.ruleForm.addTestTypeOptions.forEach(item=>{
        if (item.internaltypeid == this.ruleForm.addTestType_internaltypeid) {
          this.ruleForm.addTestTypeName = item.questiontypeName
        }
      })
      switch (this.ruleForm.addTestType_internaltypeid) {
        case 1: // 单选
          this.comp = "addTestSingleChoice";
          break;
        case 2: // 多选
          this.comp = "addTestMultipleChoice";
          break;
        case 3: // 判断
          this.comp = "addTestJudgeTest";
          break;
        case 5: // 简答
          this.comp = "addTestShortAnswer";
          break;
        case 6: // 组合
          this.comp = "addTestGroupTest";
          break;
        case 9: // 实操
          this.comp = "addTestPracticalTest";
          break;
      }
    },
    saveQuestion(flag,formName){//保存试题
      console.log(flag, formName);
      this.$refs[formName].validate((valid, formdata) => {
        if (valid) {
          let arr = []
          this.ruleForm.label.forEach(v=>{
            let labelObj = { id: v }
            arr.push(labelObj)
          })
          if (this.compValue.attachmentList.length>0) {
            this.compValue.attachmentList.forEach(attachmentVal=>{
              if (attachmentVal.status == "success") {
                delete attachmentVal.status;
              }
            })
          }
          let obj = {
            attachmentList: this.compValue.attachmentList,
            companyId: this.ruleForm.companyId,
            difficulty: this.ruleForm.difficultyValue,
            internalTypeId: 9,
            items: [],
            labelIds: [this.labelId],
            materialIds: this.ruleForm.knowledgePoints,
            parentId: 0,
            personLabels: arr,
            questionAnalysis: "",
            questionAnswer: "",
            questionContent: this.compValue.questionContent,
            questionTypeId: this.ruleForm.addTestTypeId,
            score: this.ruleForm.gradeValue,
            subjectId: this.subjectId,
            taskName: this.ruleForm.questionTitle,
            resourceCategoryId: this.ruleForm.resourceCategoryId,
          }
          if(obj.materialIds.length==0){
            this.$messageWarning('请添加知识点')
            return
          }
          if(obj.personLabels.length>5){
            this.$messageWarning('最多支持5个标签！')
            return
          }
          if(obj.questionContent==''){
            this.$messageWarning('请填写题干')
            return
          }
          this.$emit('saveQuestion',obj,flag)
        }else{
          console.log('error')
          return false
        }
      })
    },
    closeCreateQuestion(){//返回
      this.$emit('closeCreateQuestion')
    },
    changeUploadStatus(str) {//题型展示
      this.isUploading = str;
    },
  },
  watch:{
    'createQuestionShow':function(val){
      if(val){
        this.getMaterial()
        this.queryLabels()
      }else{
        this.reload()
      }
    },
        checkedTopic(val) {
            if (val.length > 0) {
                let arr = [];
                this.ruleForm.custom_label_datas.forEach(item=>{
                    if ( this.checkedTopic.indexOf( item.id ) != -1 ) {
                        let obj = {}
                        obj.id = item.id
                        arr.push(obj)
                    }
                })
                this.compValue.personLabels = arr
            }
        },
        ruleForm: {
            handler() {
                // console.log(val)
            },
            immediate: true,
            deep: true
        },
        popover_value(val) {
            this.filter_custom_label(val)
        }
  }
}
</script>
<style lang="scss" scoped>
  .create_question_wrap{
    .create_question_title{
      height: 64px;
      border-bottom: 1px solid #DDE0E2;
      position: relative;
      h2{
        font-size:16px;
        font-weight:bold;
        color:rgba(13,13,13,1);
        position: relative;
        line-height: 64px;
        padding-left: 28px;
        &::after{
          content:'';
          position: absolute;
          left: 16px;
          top: 25px;
          background: #5397F7;
          width: 4px;
          height: 12px;
        }
      }
      .btn{
        position: absolute;
        right: 20px;
        top: 17px;
        button{
          height:28px;
          background:rgba(83,151,247,1);
          border: none;
          border-radius:4px;
          color: #fff;
          padding: 0 10px;
          font-size: 12px;
          &:hover{
            opacity: 0.8;
          }
          &:last-child{
            margin-left: 12px;
          }
        }
      }
    }
    /deep/ .create_question_main{
      padding: 16px 0 16px 16px;
      box-sizing: border-box;
      overflow-y: auto;
      .questions_info{
        border-bottom: 1px solid #ccc;
        .el-form{
          display: flex;
          flex-wrap: wrap;
          .el-form-item{
            .el-form-item__label{
              line-height: 28px;
            }
            .el-form-item__content{
              line-height: 28px;
              .el-input{
                width: 120px;
              }
              .el-input__inner{
                line-height: 28px;
                height: 28px;
              }
              .el-input__icon{
                line-height: 28px;
              }
              p{
                font-weight:normal;
                line-height: 28px;
                color:rgba(13,20,30,1);
                letter-spacing: 1px;
                font-weight: 600;
              }
            }
            .resource_classify {
              .el-input{
                width: 300px;
              }
            }
          }
          .companyName{
            .el-form-item__content{
              .el-input{
                width: 220px;
              }
            }
          }
          .questionTitlt{
            .el-form-item__content{
              .el-input{
                width: 240px;
              }
            }
          }
          .knowledgePoint{
            .el-form-item__content{
              .el-select{
                width: 90%;
              }
              .el-input{
                width: 100%;
                .el-input__inner{
                  min-height: 34px !important;
                  line-height: 34px;
                }
              }
            }
          }
          .labelWrap{
            .el-form-item__content{
              display: flex;
              .el-select{
                width: 60%;
                .el-input{
                  width: 100%;
                  .el-input__inner{
                    min-height: 34px !important;
                    line-height: 34px;
                  }
                }
              }
              .customLabel{
                width: 28%;
                margin-left: 2%;
                position: relative;
                .el-input{
                  width: 100%;
                  .el-input__inner{
                    min-height: 34px !important;
                    line-height: 34px;
                    padding-right: 46px;
                  }
                }
                button{
                  width: 34px;
                  height: 30px;
                  font-size: 28px;
                  font-weight: 600;
                  background: #99A0AA;
                  border: none;
                  color: #fff;
                  text-align: center;
                  line-height: 30px;
                  padding: 0;
                  position: absolute;
                  right: 2px;
                  top: 2px;
                  border-radius: 4px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
  .el-select-dropdown{
    .el-select-dropdown__item.label_option{
      .delete_label{
        position: absolute;
        right: 20px;
        top: 10px;
      }
      &::after{
        content: '';
      }
    }
    .el-select-dropdown__item.label_option.selected{
      .delete_label{
        color: #606266;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/components/createQuestion.vue